import { useMatch } from 'react-router-dom';

export default function useCurrentPlatformId() {
  const res = useMatch('/o/:platformId/*');
  const platformId = res?.params.platformId;
  if (!platformId) {
    throw new Error('Attempted to get the current platform id from outside a platform route');
  }
  return platformId;
}
